import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {NgIf, NgOptimizedImage} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-file-upload',
  standalone: true,
    imports: [
        FormsModule,
        NgIf,
        NgOptimizedImage
    ],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true
    }
  ]
})
export class FileUploadComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() public placeholder: string = '';
  public onChange: (value: string | Blob | null) => void = () => {};
  public onTouched: () => void = () => {};
  private subscriptions: Subscription[] = [];
  public previewBase64: string | null = null;
  @Input() public loadImageFunction: (url: string) => Promise<Blob | null> = async () => null;

  constructor() {
  }

  ngOnInit() {
    this.subscriptions.push(

    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  registerOnChange(fn: (value: string | Blob | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  async writeValue(value: string | null) {
    // If the value is a string, use loadImageFunction to convert it to a Blob and set it as the preview
    if (typeof value === 'string') {
      const blob = await this.loadImageFunction(value);

      // Convert the Blob to a base64 string
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewBase64 = e.target?.result as string;
      };
      reader.readAsDataURL(blob!);

      return;
    }
  }

  handleChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files?.item(0);

    if (!file) {
      this.onChange(null);
      this.previewBase64 = null;
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewBase64 = e.target?.result as string;
    };
    reader.readAsDataURL(file);

    this.onChange(file);
  }
}
